/**
 * Salt + Soil — Bundle Cart Auto-Clear
 * ------------------------------------
 * PROBLEM: a customer who abandons a cart with an old bundle, then later
 * adds a NEW bundle (after the menu has changed), can end up with two
 * bundles in the cart, or checks out with the stale one without noticing.
 *
 * RULE: clear OLD bundle line items ONLY at the moment a NEW bundle is
 * successfully added to the cart. Never clear on a normal page load or
 * cart view, so the 30-minute abandoned-cart email still lands the
 * customer on their cart exactly as they left it.
 *
 * HOW IT DETECTS A "BUNDLE" LINE: Awtomic adds a bundle to the Shopify
 * cart as a single line item carrying hidden line-item properties
 * prefixed with an underscore (Awtomic's own docs show "_bundleProductId",
 * "_bundleName", etc. for Build-a-Box bundles). Any property key starting
 * with "_bundle" marks that line as a bundle line.
 *
 * MUST VERIFY BEFORE GOING LIVE: open the live site in an incognito
 * window, add a bundle to cart, open DevTools > Network, find the
 * /cart/add.js request, and confirm the response's "properties" object
 * actually contains a key starting with "_bundle". Salt + Soil's live
 * bundle type (Build-a-Box vs Fixed Bundle) may name this differently.
 * If the key differs, update BUNDLE_PROPERTY_PREFIX below to match.
 *
 * WHERE THIS GOES: Online Store > Themes > Edit code > Assets > Add a new
 * asset named "bundle-cart-clear.js" and paste this file's contents in.
 * Then in Layout > theme.liquid, add this line right before </body>:
 *   {{ 'bundle-cart-clear.js' | asset_url | script_tag }}
 */
(function () {
  var BUNDLE_PROPERTY_PREFIX = '_bundle';
  var CART_ADD_PATTERN = /\/cart\/add(\.js)?(\?|$)/;

  function isBundleLine(item) {
    if (!item || !item.properties) return false;
    return Object.keys(item.properties).some(function (key) {
      return key.indexOf(BUNDLE_PROPERTY_PREFIX) === 0;
    });
  }

  function clearOldBundles(justAddedKeys) {
    fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var updates = {};
        var found = false;
        (cart.items || []).forEach(function (item) {
          if (isBundleLine(item) && justAddedKeys.indexOf(item.key) === -1) {
            updates[item.key] = 0;
            found = true;
          }
        });
        if (!found) return;
        return fetch('/cart/update.js', {
          method: 'POST',
          credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ updates: updates })
        });
      })
      .catch(function (err) {
        console.error('[bundle-cart-clear] failed to clear old bundle(s):', err);
      });
  }

  function handleAddResponse(responseBody) {
    try {
      var data = typeof responseBody === 'string' ? JSON.parse(responseBody) : responseBody;
      // /cart/add.js returns either a single item object or {items: [...]}
      var addedItems = data.items ? data.items : [data];
      var relevant = addedItems.filter(isBundleLine);
      if (!relevant.length) return; // not a bundle add, leave the cart alone
      var justAddedKeys = relevant.map(function (i) { return i.key; });
      clearOldBundles(justAddedKeys);
    } catch (e) {
      console.error('[bundle-cart-clear] could not parse add response:', e);
    }
  }

  // --- Patch fetch (most themes / apps use this) ---
  var originalFetch = window.fetch;
  window.fetch = function () {
    var args = arguments;
    var url = args[0] instanceof Request ? args[0].url : args[0];
    var isCartAdd = typeof url === 'string' && CART_ADD_PATTERN.test(url);
    return originalFetch.apply(this, args).then(function (response) {
      if (isCartAdd && response.ok) {
        response.clone().json().then(handleAddResponse).catch(function () {});
      }
      return response;
    });
  };

  // --- Patch XHR too, in case Awtomic's widget uses XHR instead of fetch ---
  var originalOpen = XMLHttpRequest.prototype.open;
  var originalSend = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.open = function (method, url) {
    this._isCartAdd = typeof url === 'string' && CART_ADD_PATTERN.test(url);
    return originalOpen.apply(this, arguments);
  };
  XMLHttpRequest.prototype.send = function () {
    if (this._isCartAdd) {
      this.addEventListener('load', function () {
        if (this.status >= 200 && this.status < 300) {
          handleAddResponse(this.responseText);
        }
      });
    }
    return originalSend.apply(this, arguments);
  };
})();